// Role Configuration File
// This file contains all role definitions and permissions in a centralized, manageable way

// Role IDs mapping
export const ROLE_IDS = {
  ADMIN: 1,
  TEAM_MEMBER: 2,
  SERVICE_MANAGER: 3,
  JR_SERVICE_MANAGER: 4,
  TEAM_LEADER: 5,
  PEOPLE_MANAGER: 6,
  DELIVERY_MANAGER: 7
};

// Role names for database mapping
export const ROLE_NAMES = {
  [ROLE_IDS.ADMIN]: 'admin',
  [ROLE_IDS.TEAM_MEMBER]: 'team_member',
  [ROLE_IDS.SERVICE_MANAGER]: 'service_manager',
  [ROLE_IDS.JR_SERVICE_MANAGER]: 'jr_service_manager',
  [ROLE_IDS.TEAM_LEADER]: 'team_leader',
  [ROLE_IDS.PEOPLE_MANAGER]: 'people_manager',
  [ROLE_IDS.DELIVERY_MANAGER]: 'delivery_manager'
};

// Display names for UI
export const ROLE_DISPLAY_NAMES = {
  [ROLE_IDS.ADMIN]: 'Admin',
  [ROLE_IDS.TEAM_MEMBER]: 'Team Member',
  [ROLE_IDS.SERVICE_MANAGER]: 'Service Manager',
  [ROLE_IDS.JR_SERVICE_MANAGER]: 'JR Service Manager',
  [ROLE_IDS.TEAM_LEADER]: 'Team Leader',
  [ROLE_IDS.PEOPLE_MANAGER]: 'People Manager',
  [ROLE_IDS.DELIVERY_MANAGER]: 'Delivery Manager'
};

// Role hierarchy levels (higher = more permissions)
export const ROLE_HIERARCHY = {
  [ROLE_IDS.ADMIN]: 6,
  [ROLE_IDS.DELIVERY_MANAGER]: 5.5,
  [ROLE_IDS.PEOPLE_MANAGER]: 5,
  [ROLE_IDS.SERVICE_MANAGER]: 4,
  [ROLE_IDS.TEAM_LEADER]: 3,
  [ROLE_IDS.JR_SERVICE_MANAGER]: 2,
  [ROLE_IDS.TEAM_MEMBER]: 1
};

// Page access permissions
export const PAGE_PERMISSIONS = {
  // Home - accessible to all authenticated users
  '/': [ROLE_IDS.ADMIN, ROLE_IDS.DELIVERY_MANAGER, ROLE_IDS.PEOPLE_MANAGER, ROLE_IDS.SERVICE_MANAGER, ROLE_IDS.JR_SERVICE_MANAGER, ROLE_IDS.TEAM_LEADER, ROLE_IDS.TEAM_MEMBER],
  // Anteprima nuova Home (attiva solo con ENABLE_HOME_V2)
  '/home-v2': [ROLE_IDS.ADMIN, ROLE_IDS.DELIVERY_MANAGER, ROLE_IDS.PEOPLE_MANAGER, ROLE_IDS.SERVICE_MANAGER, ROLE_IDS.JR_SERVICE_MANAGER, ROLE_IDS.TEAM_LEADER, ROLE_IDS.TEAM_MEMBER],
  
  // My Area - accessible to all users
  '/daily-tracking': [ROLE_IDS.ADMIN, ROLE_IDS.DELIVERY_MANAGER, ROLE_IDS.PEOPLE_MANAGER, ROLE_IDS.SERVICE_MANAGER, ROLE_IDS.JR_SERVICE_MANAGER, ROLE_IDS.TEAM_LEADER, ROLE_IDS.TEAM_MEMBER],
  // Anteprima nuova Daily Tracking (attiva solo con ENABLE_DAILY_TRACKING_V2)
  '/daily-tracking-v2': [ROLE_IDS.ADMIN, ROLE_IDS.DELIVERY_MANAGER, ROLE_IDS.PEOPLE_MANAGER, ROLE_IDS.SERVICE_MANAGER, ROLE_IDS.JR_SERVICE_MANAGER, ROLE_IDS.TEAM_LEADER, ROLE_IDS.TEAM_MEMBER],
  '/monthly-user-view': [ROLE_IDS.ADMIN, ROLE_IDS.DELIVERY_MANAGER, ROLE_IDS.PEOPLE_MANAGER, ROLE_IDS.SERVICE_MANAGER, ROLE_IDS.JR_SERVICE_MANAGER, ROLE_IDS.TEAM_LEADER, ROLE_IDS.TEAM_MEMBER],
  // Anteprima nuova My month (attiva solo con ENABLE_MY_MONTH_V2)
  '/monthly-user-view-v2': [ROLE_IDS.ADMIN, ROLE_IDS.DELIVERY_MANAGER, ROLE_IDS.PEOPLE_MANAGER, ROLE_IDS.SERVICE_MANAGER, ROLE_IDS.JR_SERVICE_MANAGER, ROLE_IDS.TEAM_LEADER, ROLE_IDS.TEAM_MEMBER],
  '/tracking-list-user': [ROLE_IDS.ADMIN, ROLE_IDS.DELIVERY_MANAGER, ROLE_IDS.PEOPLE_MANAGER, ROLE_IDS.SERVICE_MANAGER, ROLE_IDS.JR_SERVICE_MANAGER, ROLE_IDS.TEAM_LEADER, ROLE_IDS.TEAM_MEMBER],
  // Anteprima nuova lista worklog (attiva solo con ENABLE_WORKLOGS_V2)
  '/tracking-list-user-v2': [ROLE_IDS.ADMIN, ROLE_IDS.DELIVERY_MANAGER, ROLE_IDS.PEOPLE_MANAGER, ROLE_IDS.SERVICE_MANAGER, ROLE_IDS.JR_SERVICE_MANAGER, ROLE_IDS.TEAM_LEADER, ROLE_IDS.TEAM_MEMBER],
  
  // Manager Area - accessible to managers and above
  '/monthly-mng-view': [ROLE_IDS.ADMIN, ROLE_IDS.DELIVERY_MANAGER, ROLE_IDS.PEOPLE_MANAGER, ROLE_IDS.SERVICE_MANAGER, ROLE_IDS.JR_SERVICE_MANAGER, ROLE_IDS.TEAM_LEADER],
  // Anteprima nuova Monthly Tracking View (attiva solo con ENABLE_MONTHLY_MNG_VIEW_V2)
  '/monthly-mng-view-v2': [ROLE_IDS.ADMIN, ROLE_IDS.DELIVERY_MANAGER, ROLE_IDS.PEOPLE_MANAGER, ROLE_IDS.SERVICE_MANAGER, ROLE_IDS.JR_SERVICE_MANAGER, ROLE_IDS.TEAM_LEADER],
  '/monthly-mng-view/project/:projectId': [ROLE_IDS.ADMIN, ROLE_IDS.DELIVERY_MANAGER, ROLE_IDS.PEOPLE_MANAGER, ROLE_IDS.SERVICE_MANAGER, ROLE_IDS.JR_SERVICE_MANAGER, ROLE_IDS.TEAM_LEADER],
  '/list-tracking-view': [ROLE_IDS.ADMIN, ROLE_IDS.DELIVERY_MANAGER, ROLE_IDS.PEOPLE_MANAGER, ROLE_IDS.SERVICE_MANAGER, ROLE_IDS.JR_SERVICE_MANAGER, ROLE_IDS.TEAM_LEADER],
  // Anteprima nuova lista worklog dei progetti (attiva solo con ENABLE_WORKLOGS_V2)
  '/list-tracking-view-v2': [ROLE_IDS.ADMIN, ROLE_IDS.DELIVERY_MANAGER, ROLE_IDS.PEOPLE_MANAGER, ROLE_IDS.SERVICE_MANAGER, ROLE_IDS.JR_SERVICE_MANAGER, ROLE_IDS.TEAM_LEADER],
  
  // People Manager Area - accessible only to users with org_role_id = 2 (people_manager)
  '/monthly-people-mng-view': [], // Accesso controllato da org_role_id, non da role_id
  '/monthly-people-mng-view-v2': [], // Anteprima nuova vista PM (ENABLE_MONTHLY_PM_VIEW_V2), accesso da org_role_id
  '/monthly-people-mng-view/user/:userId': [], // Accesso controllato da org_role_id, non da role_id
  '/list-tracking-people-mng-view': [], // Accesso controllato da org_role_id, non da role_id
  '/list-tracking-people-mng-view-v2': [], // Anteprima nuova lista worklog (ENABLE_WORKLOGS_V2), accesso da org_role_id
  
  // Projects - accessible to admin, delivery manager and service managers
  '/projects': [ROLE_IDS.ADMIN, ROLE_IDS.DELIVERY_MANAGER, ROLE_IDS.SERVICE_MANAGER],
  '/projects/:id': [ROLE_IDS.ADMIN, ROLE_IDS.DELIVERY_MANAGER, ROLE_IDS.SERVICE_MANAGER],
  // Anteprima nuova pagina progetti (attiva solo con ENABLE_PROJECTS_V2): la scheda aperta è nel percorso
  '/projects/:id/:tab': [ROLE_IDS.ADMIN, ROLE_IDS.DELIVERY_MANAGER, ROLE_IDS.SERVICE_MANAGER],
  '/projects-v2': [ROLE_IDS.ADMIN, ROLE_IDS.DELIVERY_MANAGER, ROLE_IDS.SERVICE_MANAGER],
  '/projects-v2/:id': [ROLE_IDS.ADMIN, ROLE_IDS.DELIVERY_MANAGER, ROLE_IDS.SERVICE_MANAGER],
  '/projects-v2/:id/:tab': [ROLE_IDS.ADMIN, ROLE_IDS.DELIVERY_MANAGER, ROLE_IDS.SERVICE_MANAGER],
  '/customers':[ROLE_IDS.ADMIN, ROLE_IDS.DELIVERY_MANAGER, ROLE_IDS.SERVICE_MANAGER],
  // Anteprima nuova pagina clienti (attiva solo con ENABLE_CUSTOMERS_V2)
  '/customers-v2': [ROLE_IDS.ADMIN, ROLE_IDS.DELIVERY_MANAGER, ROLE_IDS.SERVICE_MANAGER],
  '/contracts': [ROLE_IDS.ADMIN], // ROLE_IDS.DELIVERY_MANAGER, ROLE_IDS.SERVICE_MANAGER],
  // Anteprima nuova pagina contratti (attiva solo con ENABLE_CONTRACTS_V2)
  '/contracts-v2': [ROLE_IDS.ADMIN, ROLE_IDS.DELIVERY_MANAGER, ROLE_IDS.SERVICE_MANAGER],
  
  // Admin Area - accessible only to admin and people manager (DELIVERY_MANAGER excluded)
  
  '/users': [ROLE_IDS.ADMIN],
  '/users/:id': [ROLE_IDS.ADMIN],
  // Anteprima nuova pagina utenti (attiva solo con ENABLE_USERS_V2)
  '/users-v2': [ROLE_IDS.ADMIN],
  '/activities': [ROLE_IDS.ADMIN],
  // Anteprima nuova pagina activities (attiva solo con ENABLE_ACTIVITIES_V2)
  '/activities-v2': [ROLE_IDS.ADMIN],
  '/project-reporting': [ROLE_IDS.ADMIN],
  
  // Profile - accessible to all authenticated users
  '/profile': [ROLE_IDS.ADMIN, ROLE_IDS.DELIVERY_MANAGER, ROLE_IDS.PEOPLE_MANAGER, ROLE_IDS.SERVICE_MANAGER, ROLE_IDS.JR_SERVICE_MANAGER, ROLE_IDS.TEAM_LEADER, ROLE_IDS.TEAM_MEMBER],
  // Anteprima nuovo profilo (attivo solo con ENABLE_PROFILE_V2)
  '/profile-v2': [ROLE_IDS.ADMIN, ROLE_IDS.DELIVERY_MANAGER, ROLE_IDS.PEOPLE_MANAGER, ROLE_IDS.SERVICE_MANAGER, ROLE_IDS.JR_SERVICE_MANAGER, ROLE_IDS.TEAM_LEADER, ROLE_IDS.TEAM_MEMBER]
};

// Menu section permissions
// Note: 'People Manager Area' access is controlled by org_role_id = 2, not role_id
export const MENU_SECTION_PERMISSIONS = {
  'My Area': [ROLE_IDS.ADMIN, ROLE_IDS.DELIVERY_MANAGER, ROLE_IDS.PEOPLE_MANAGER, ROLE_IDS.SERVICE_MANAGER, ROLE_IDS.JR_SERVICE_MANAGER, ROLE_IDS.TEAM_LEADER, ROLE_IDS.TEAM_MEMBER],
  'Manager Area': [ROLE_IDS.ADMIN, ROLE_IDS.DELIVERY_MANAGER, ROLE_IDS.PEOPLE_MANAGER, ROLE_IDS.SERVICE_MANAGER, ROLE_IDS.JR_SERVICE_MANAGER, ROLE_IDS.TEAM_LEADER],
  'People Manager Area': [], // Accesso controllato da org_role_id = 2, non da role_id
  'Admin Area': [ROLE_IDS.ADMIN]
};

// Individual menu item permissions
export const MENU_ITEM_PERMISSIONS = {
  'Home': [ROLE_IDS.ADMIN, ROLE_IDS.DELIVERY_MANAGER, ROLE_IDS.PEOPLE_MANAGER, ROLE_IDS.SERVICE_MANAGER, ROLE_IDS.JR_SERVICE_MANAGER, ROLE_IDS.TEAM_LEADER, ROLE_IDS.TEAM_MEMBER],
  'Daily Tracking': [ROLE_IDS.ADMIN, ROLE_IDS.DELIVERY_MANAGER, ROLE_IDS.PEOPLE_MANAGER, ROLE_IDS.SERVICE_MANAGER, ROLE_IDS.JR_SERVICE_MANAGER, ROLE_IDS.TEAM_LEADER, ROLE_IDS.TEAM_MEMBER],
  'Monthly View': [ROLE_IDS.ADMIN, ROLE_IDS.DELIVERY_MANAGER, ROLE_IDS.PEOPLE_MANAGER, ROLE_IDS.SERVICE_MANAGER, ROLE_IDS.JR_SERVICE_MANAGER, ROLE_IDS.TEAM_LEADER, ROLE_IDS.TEAM_MEMBER],
  'List View': [ROLE_IDS.ADMIN, ROLE_IDS.DELIVERY_MANAGER, ROLE_IDS.PEOPLE_MANAGER, ROLE_IDS.SERVICE_MANAGER, ROLE_IDS.JR_SERVICE_MANAGER, ROLE_IDS.TEAM_LEADER, ROLE_IDS.TEAM_MEMBER],
  'Monthly Tracking View': [ROLE_IDS.ADMIN, ROLE_IDS.DELIVERY_MANAGER, ROLE_IDS.PEOPLE_MANAGER, ROLE_IDS.SERVICE_MANAGER, ROLE_IDS.JR_SERVICE_MANAGER, ROLE_IDS.TEAM_LEADER],
  'List Tracking View': [ROLE_IDS.ADMIN, ROLE_IDS.DELIVERY_MANAGER, ROLE_IDS.PEOPLE_MANAGER, ROLE_IDS.SERVICE_MANAGER, ROLE_IDS.JR_SERVICE_MANAGER, ROLE_IDS.TEAM_LEADER],
  'Monthly People Manager View': [], // Accesso controllato da org_role_id = 2
  'List People Manager View': [], // Accesso controllato da org_role_id = 2
  'Projects': [ROLE_IDS.ADMIN, ROLE_IDS.DELIVERY_MANAGER, ROLE_IDS.SERVICE_MANAGER],
  'Project Reporting': [ROLE_IDS.ADMIN],
  // Allineato a PAGE_PERMISSIONS['/customers']: il People Manager non accede alla pagina
  'Customers': [ROLE_IDS.ADMIN, ROLE_IDS.DELIVERY_MANAGER, ROLE_IDS.SERVICE_MANAGER],
  'Contracts': [ROLE_IDS.ADMIN, ROLE_IDS.DELIVERY_MANAGER, ROLE_IDS.SERVICE_MANAGER],
  // Allineato a PAGE_PERMISSIONS['/users']: solo Admin
  'Users': [ROLE_IDS.ADMIN],
  'Activities': [ROLE_IDS.ADMIN]
};

// Feature permissions (for specific functionality)
export const FEATURE_PERMISSIONS = {
  // User management
  'MANAGE_USERS': [ROLE_IDS.ADMIN, ROLE_IDS.PEOPLE_MANAGER],
  
  // Project management - DELIVERY_MANAGER has full access to all projects
  'MANAGE_PROJECTS': [ROLE_IDS.ADMIN, ROLE_IDS.DELIVERY_MANAGER, ROLE_IDS.SERVICE_MANAGER],
  
  // Customer management
  'MANAGE_CUSTOMERS': [ROLE_IDS.ADMIN, ROLE_IDS.DELIVERY_MANAGER, ROLE_IDS.PEOPLE_MANAGER],
  
  // Manager reports - DELIVERY_MANAGER can view all manager reports
  'VIEW_MANAGER_REPORTS': [ROLE_IDS.ADMIN, ROLE_IDS.DELIVERY_MANAGER, ROLE_IDS.PEOPLE_MANAGER, ROLE_IDS.SERVICE_MANAGER, ROLE_IDS.JR_SERVICE_MANAGER, ROLE_IDS.TEAM_LEADER],
  
  // Team management
  'MANAGE_TEAMS': [ROLE_IDS.ADMIN, ROLE_IDS.DELIVERY_MANAGER, ROLE_IDS.PEOPLE_MANAGER, ROLE_IDS.SERVICE_MANAGER, ROLE_IDS.JR_SERVICE_MANAGER, ROLE_IDS.TEAM_LEADER],
  
  // Worklog management
  'MANAGE_WORKLOGS': [ROLE_IDS.ADMIN, ROLE_IDS.DELIVERY_MANAGER, ROLE_IDS.PEOPLE_MANAGER, ROLE_IDS.SERVICE_MANAGER, ROLE_IDS.JR_SERVICE_MANAGER, ROLE_IDS.TEAM_LEADER, ROLE_IDS.TEAM_MEMBER]
};

// Role groups for easy permission checking
export const ROLE_GROUPS = {
  // All authenticated users
  ALL_USERS: [ROLE_IDS.ADMIN, ROLE_IDS.DELIVERY_MANAGER, ROLE_IDS.PEOPLE_MANAGER, ROLE_IDS.SERVICE_MANAGER, ROLE_IDS.JR_SERVICE_MANAGER, ROLE_IDS.TEAM_LEADER, ROLE_IDS.TEAM_MEMBER],
  
  // Managers and above (excludes team members)
  MANAGERS: [ROLE_IDS.ADMIN, ROLE_IDS.DELIVERY_MANAGER, ROLE_IDS.PEOPLE_MANAGER, ROLE_IDS.SERVICE_MANAGER, ROLE_IDS.JR_SERVICE_MANAGER, ROLE_IDS.TEAM_LEADER],
  
  // Admin area access (DELIVERY_MANAGER excluded)
  ADMIN_AREA: [ROLE_IDS.ADMIN, ROLE_IDS.PEOPLE_MANAGER],
  
  // Top level management
  TOP_MANAGEMENT: [ROLE_IDS.ADMIN, ROLE_IDS.DELIVERY_MANAGER, ROLE_IDS.PEOPLE_MANAGER]
};
